"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_grid_layout_1 = require("react-grid-layout");
var responsive_util_1 = require("../responsive/responsive-util");
var ResponsiveGridLayout = react_grid_layout_1.WidthProvider(react_grid_layout_1.Responsive);
var cols = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 };
var breakPoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
var ResizableGrid = function (_a) {
    var children = _a.children, layouts = _a.layouts, onLayoutChange = _a.onLayoutChange, _b = _a.rowHeight, rowHeight = _b === void 0 ? 140 : _b, _c = _a.draggableHandle, draggableHandle = _c === void 0 ? '.draggable-handle' : _c;
    var mappedChildren = [];
    react_1.default.Children.forEach(children, function (child) {
        if (child && react_1.default.isValidElement(child)) {
            mappedChildren.push(react_1.default.createElement("div", { key: child.key || '' }, child));
        }
    });
    var isMobile = responsive_util_1.useMobileView();
    return (react_1.default.createElement(ResponsiveGridLayout, { measureBeforeMount: true, cols: cols, layouts: layouts, rowHeight: rowHeight, containerPadding: isMobile ? [0, 0] : [10, 10], breakpoints: breakPoints, draggableHandle: draggableHandle, onLayoutChange: function (_, allLayouts) { return onLayoutChange(allLayouts); } }, mappedChildren));
};
ResizableGrid.displayName = 'ResizableGrid';
exports.default = ResizableGrid;
//# sourceMappingURL=resizable-grid.component.js.map